import { render, staticRenderFns } from "./CategoryNavigation.vue?vue&type=template&id=b26381dc&scoped=true"
import script from "./CategoryNavigation.vue?vue&type=script&lang=js"
export * from "./CategoryNavigation.vue?vue&type=script&lang=js"
import style0 from "./CategoryNavigation.vue?vue&type=style&index=0&id=b26381dc&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b26381dc",
  null
  
)

export default component.exports